<template>
  <div>
    <v-card
      v-if="!isSmAndDown && urlGamification"
      min-height="1100"
      height="1100"
    >
      <div
        style="height: 100%; display: flex; justify-content: center; align-items: center"
      >
        <iframe
          v-if="urlGamification"
          class="pt-3"
          height="100%"
          width="100%"
          style="border: none"
          :src="urlGamification"
        ></iframe>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-card>
    <v-expansion-panel v-if="isSmAndDown && urlGamification">
      <v-expansion-panel-content>
        <div
          style="display: flex; align-items: center; height: 40px"
          slot="header"
        >
          <v-icon color="primary" class="mr-3">las la-gift</v-icon>
          <span class="title-header primary--text "
            >Suas indicações podem virar recompensas!</span
          >
        </div>
        <v-card min-height="900" height="900">
          <iframe
            class="pt-3"
            height="100%"
            width="100%"
            style="border: none"
            :src="urlGamification"
          ></iframe>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['currentStep', 'eventID', 'orderData', 'store']),
    urlApi() {
      switch (process.env.NODE_ENV) {
        case 'development':
          return `https://soulapi.dev.btservers.com.br/api/`;
        case 'homologation':
          return `https://soulapi.homolog.btservers.com.br/api/`;
        default:
          return `https://soulapi.blueticket.com.br/api/`;
      }
    },
    urlGamification() {
      if (
        this.orderData &&
        this.orderData.orderData &&
        this.orderData.orderData.gamification &&
        this.eventID
      ) {
        return `${this.store.apiUrl}/api/event/gamification/ranking/${this.eventID}/${this.orderData.orderData.gamification.chave}/html`;
      } else return '';
    },
  },
};
</script>

<style scoped>
.title-header {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}
</style>
